/**
 * 跨 feature 事件
 * ------------------------------------------------------------
 * 硬约束：features/A 不得直接 import features/B，通信走 domain 或事件总线。
 *
 * 事件清单（与原型契约对齐）：
 * - org:changed          OrgSwitcher 切换 → 全站重绘
 * - nav:push / nav:back  路由与视图栈变化 → 头部返回路径
 * - prefs:changed        「我的」改底栏配置 / 外观 → BottomBar / ThemeProvider
 * - chat:activity        会话 store 广播回答阶段/状态 → 企管助手小人念叨（shell/aichar/activity.ts）
 */

type Handler = (...args: any[]) => void
const bus = new Map<string, Set<Handler>>()

export function on(event: string, fn: Handler) {
  if (!bus.has(event)) bus.set(event, new Set())
  bus.get(event)!.add(fn)
  return () => off(event, fn)
}
export function off(event: string, fn: Handler) { bus.get(event)?.delete(fn) }
export function emit(event: string, ...args: any[]) {
  bus.get(event)?.forEach(fn => { try { fn(...args) } catch (e) { console.error(`[event ${event}]`, e) } })
}
